import React from 'react';
import { AlertTriangle } from 'lucide-react';

// The server marks a diagnosis it could not get from the AI: degraded=true on
// the live response, and ai_model_version "rule-based-fallback" on the stored
// row (history has no degraded column). Either one means the causes are
// generic suggestions for the symptom, so there is no AI confidence to show.
export const isFallbackDiagnosis = (diagnosis) =>
  Boolean(diagnosis?.degraded) || diagnosis?.ai_model_version === 'rule-based-fallback';

const DiagnosisFallbackNotice = () => (
  <div role="status" className="bg-warning-tint rounded-card p-4 border border-warning-border flex items-start">
    <AlertTriangle className="h-5 w-5 text-warning mr-3 mt-0.5 flex-shrink-0" />
    <div className="text-sm text-ink">
      <p className="font-semibold">AI was unavailable for this diagnosis.</p>
      <p className="mt-1 text-ink-muted">
        These are general suggestions for the symptom, not an analysis of this vehicle.
        Check them before quoting.
      </p>
    </div>
  </div>
);

export default DiagnosisFallbackNotice;
